import React, { SVGProps } from "react";

export default function ActivityIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 26 27" width={26} height={27} {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.587}
        transform="translate(1.282 1.385)"
      >
        <path d="M10.753 7.181h9.523m-9.523 9.524h9.523" />
        <circle cx={5.991} cy={7.181} r={2.381} />
        <circle cx={5.991} cy={16.705} r={2.381} />
        <path d="M3.178 23.562l-.758-.047a2.202 2.202 0 01-2.052-2.048l-.024-.397a136.375 136.375 0 010-18.277l.024-.397A2.21 2.21 0 012.42.368l.396-.024a136.375 136.375 0 0118.278 0l.397.024a2.21 2.21 0 012.027 2.052l.024.396c.409 6.086.409 12.192 0 18.278l-.024.397a2.206 2.206 0 01-2.051 2.031 137.3 137.3 0 01-18.29.04z" />
      </g>
    </svg>
  );
}
